import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import { header as e2eClasses } from 'constants/e2eClasses'

export const HeaderContainer = styled.div.attrs(props => ({
  className: `${props.e2eClass || 'header'}${e2eClasses.header}`
}))`
  width: 100%;
  background-color: ${({ theme, background }) => background || theme.colors.blue};
  border-radius: 3px;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 20px;
  height: 40px;

  ${({ withBorderBottom, theme }) =>
    withBorderBottom &&
    `
      border-bottom: 2px solid ${theme.colors.grayLighter};
    `}

  ${({ customHeight }) =>
    customHeight &&
    `
      height: ${customHeight}px;
    `}

  ${({ noLeftPadding }) => noLeftPadding && `padding-left: 0;`}

  ${mediaQueries.tablet`
    border-radius: unset;
    height: 60px;
    padding: 24px 65px;
    ${({ noCenter }) => !noCenter && `padding: 7px 60px;`}

    ${({ withBorderBottom, theme }) =>
      withBorderBottom &&
      `
        border-bottom: 2px solid ${theme.colors.white};
      `}
  `};

  ${mediaQueries.mobile`
    padding: 7px 12px;
    border-bottom: none;
    height: 40px;
  `};
`

export const SubContainer = styled.div`
  display: flex;
  flex: 1 80%;
`

export const TypeText = styled.span.attrs(props => ({
  className: `${props.e2eClass || 'header'}${e2eClasses.type}`
}))`
  padding: 0 7px 0 15px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  margin-left: 20px;
  ${({ noUppercase }) => !noUppercase && 'text-transform: uppercase'};
  font-size: 16px;

  ${mediaQueries.tablet`
    padding: 0 5px;
    ${({ isInactive }) => (isInactive ? 'font-size: 18px' : 'font-size: 20px')};
  `};

  ${mediaQueries.mobile`
    padding: 0 5px;
    margin-left: 0;
    padding: 0 7px 0 0;
    ${({ isInactive }) => (isInactive ? 'font-size: 14px' : 'font-size: 16px')};
  `};
`

export const HeaderText = styled.span.attrs(props => ({
  className: `${props.e2eClass || 'header'}${e2eClasses.title}`
}))`
  display: flex;
  flex: 1;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 18px;

  ${({ color }) => color && `color: ${color}`};

  ${mediaQueries.tablet`
    font-size: ${({ isSublos }) => (isSublos ? '18px' : '24px')}
  `};

  ${mediaQueries.mobile`
    font-size: 18px;
  `};
`

export const LeftContainer = styled.div`
  display: flex;
  flex: 1 100%;
  align-items: center;
`

export const RightContainer = styled.div`
  display: flex;
  flex: 1 60%;
  justify-content: flex-end;
  align-items: center;
`

export const IconWrapper = styled.div.attrs(props => ({
  className: `${props.e2eClass || 'header'}${e2eClasses.icon}`
}))`
  margin: 5px 5px 0 0;
`
